import { NgModule } from '@angular/core';
import { HasFeatureDirective } from './has-feature.directive';

@NgModule({
  declarations: [HasFeatureDirective],
  exports: [HasFeatureDirective],
})
export class PolicyModule {}
